import '@babel/polyfill';
import { registerHomepageUGCSection } from '../sections/homepageugc';
import { registerCustomEventHandler } from '../biotrust/trackers/customEventHandler';
import '../sections/mb-testimonials-carousel';
import '../sections/logo-bar';
import '../../styles/sections/mb-image-with-text.scss';
import '../../styles/sections/mb-images-with-text.scss';
import '../../styles/sections/mb-our-mission.scss';
import '../../styles/sections/mb-solutions.scss';
import '../../styles/sections/mb-testimonials-carousel.scss';
$(function () {
  registerHomepageUGCSection(); // dynamic sections (Seed half image hero & Shop by health interest) that contain custom event attributes

  var $customEventContainers = $('.shopify-section.seed-half-image-hero, .shopify-section.feature-icon-columns');
  registerCustomEventHandler($customEventContainers); // Slick slider clones the slides, so we need to use a delegated event handler

  registerCustomEventHandler($('#featured-product-slider, .shopify-section.feature-columns'), true);
});